export const SELECT_GRAPH_DATE_RANGE = 'SELECT_GRAPH_DATE_RANGE'
export const TOGGLE_GRAPH_Y_AXIS = 'TOGGLE_GRAPH_Y_AXIS'
export const SET_GRAPH_ACCESSORS = 'SET_GRAPH_ACCESSORS'
